import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { CloudUpload, Delete, InsertLink, OpenInNew } from "@material-ui/icons";
import React, { useState } from "react";
import * as dateFNS from 'date-fns';
import { toast } from "react-toastify";
import swal from 'sweetalert';
import { producaov2 } from "../../../../../../services/apis";

const renderUser = ({ user }) => {
  return (
    <Box display="flex" gridGap="0.25rem" flexDirection="column">
      <Typography variant="body2">{`[${user?.id}] ${user?.name}`}</Typography>
      <Typography variant="body2">{`${user?.email}`}</Typography>
    </Box>
  )
}

const renderCourse = ({ course }) => {
  return (
    <>
      <Typography variant="body2">{`[${course?.id}] ${course?.name}`}</Typography>
    </>
  )
}

const renderDates = ({ createdAt, updatedAt }) => {
  return (
    <Box display="flex" gridGap="0.5rem" flexDirection="column">
      <Typography variant="body2" noWrap>{`Criação: ${dateFNS.format(new Date(createdAt), 'dd/MM/yyyy')}`}</Typography>
      <Typography variant="body2" noWrap>{`Atualização: ${dateFNS.format(new Date(updatedAt), 'dd/MM/yyyy')}`}</Typography>
    </Box>
  )
}

function CertificatesRow({ certificate, refreshData }) {
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);

  const handleCopyLink = () => {
    // Funciona somente em HTTPS
    navigator.clipboard.writeText(certificate?.link);
    toast.success("Link copiado com sucesso");
  }
  
  const handleDeleteCertificate = async () => {
    const willDelete = await swal({
      title: 'Deseja realmente excluir o certificado?',
      text: 'Essa ação é irreversível',
      icon: 'warning',
      buttons: ['Cancelar', 'Excuir'],
      dangerMode: true
    });
  
    if(!willDelete) {
      return;
    }
  
    setLoadingDelete(true);

    try {
      await producaov2.delete(`/admin/certificados/${certificate?.id}`);
      refreshData();
      toast.success("Certificado excluido com sucesso");
    } catch(error) {
      toast.error("Houve um erro ao deletar certificado");
    } finally {
      setLoadingDelete(false);
    }
  }

  const handleUploadCertificate = async (e) => {
    const [file] = e.target.files;
    
    if(!file) {
      return;
    }

    setLoadingUpload(true);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await producaov2.post(`/admin/certificados/${certificate?.id}/upload`, formData);

      toast.success("Certificado alterado com sucesso");
      window.open(response.data, '_blank');
      refreshData();
    } catch(error) {
      toast.error("Houve um erro ao alterar o certificado");
    } finally {
      setLoadingUpload(false);
    }
  }

  const handleUploadClick = () => {
    const inputFile = document.getElementById(`certificate-file-${certificate?.id}`);
    inputFile.click();
  }

  return (
    <TableRow>
      <TableCell>{certificate?.id}</TableCell>
      <TableCell>{renderUser({user: certificate?.user})}</TableCell>
      <TableCell>{renderCourse({course: certificate?.course})}</TableCell>
      <TableCell>{renderDates({updatedAt: certificate?.updatedAt, createdAt: certificate?.createdAt})}</TableCell>
      <TableCell>
        <Grid container wrap="nowrap">
          <Grid item>
            <IconButton title="Copiar link do certificado" onClick={handleCopyLink}>
              <InsertLink />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton title="Abrir link do certificado" component="a" href={certificate?.link} target="_blank">
              <OpenInNew />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton title="Subir novo certificado" onClick={handleUploadClick}>
              {loadingUpload ? <CircularProgress size={16}/> : <CloudUpload />}
              <input
                id={`certificate-file-${certificate?.id}`}
                type="file"
                accept="application/pdf"
                style={{ display: 'none' }}
                onChange={handleUploadCertificate}  
              />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton title="Excluir certificado" disabled={loadingDelete} onClick={handleDeleteCertificate}>
              {loadingDelete ? <CircularProgress size={16}/> : <Delete />}
            </IconButton>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
}

export default function CertificatesList({
  certificates = [],
  page = 1,
  limit = 50,
  loading = false,
  refreshData = () => {},
  onChangePage = () => {},
  onChangeLimit = () => {}
}) {
  return (
    <TableContainer component={Paper} style={{overflowX: 'auto'}}>
      <Table>
        <TableHead>
          <TableCell>ID</TableCell>
          <TableCell>Aluno</TableCell>
          <TableCell>Curso</TableCell>
          <TableCell>Data</TableCell>
          <TableCell>Ações</TableCell>
        </TableHead>
        <TableBody>
          {loading && (Array(limit).fill(0).map((_, index) => {
            return (
              <TableRow key={index}>
                <TableCell colSpan={5}>
                  <Box height={12} bgcolor="#eee" width="100%" />
                </TableCell>
              </TableRow>
            )
          }))}
          {!loading && (
            certificates?.data?.map(certificate => {
              return <CertificatesRow key={certificate?.id} certificate={certificate} refreshData={refreshData} />
            })
          )}
        </TableBody>
      </Table>
        {certificates?.paging && (
          <TablePagination
            component="div"
            rowsPerPageOptions={[10, 25, 50, 100]}
            count={certificates?.paging?.total}
            rowsPerPage={limit}
            page={page - 1}
            onChangePage={(_, page) => onChangePage(page + 1)}
            onChangeRowsPerPage={(e) => onChangeLimit(e.target.value)}
          />
        )}
    </TableContainer>
  );
}
